export type LangCode =
  | "en" | "es" | "pt" | "fr" | "zh" | "de" | "it" | "ar"
  | "ja" | "sv" | "af";

export type Language = {
  code: LangCode;
  label: string;        // shown on the tile in its own script
  english: string;      // english name (debug / accessibility)
  flag: string;         // emoji flag
  rtl?: boolean;
};

// Ordered by likely tourist usage (World Cup in MTY).
export const LANGUAGES: Language[] = [
  { code: "en", label: "English",   english: "English",    flag: "🇺🇸" },
  { code: "es", label: "Español",   english: "Spanish",    flag: "🇲🇽" },
  { code: "pt", label: "Português", english: "Portuguese", flag: "🇧🇷" },
  { code: "fr", label: "Français",  english: "French",     flag: "🇫🇷" },
  { code: "zh", label: "中文",       english: "Chinese",    flag: "🇨🇳" },
  { code: "de", label: "Deutsch",   english: "German",     flag: "🇩🇪" },
  { code: "it", label: "Italiano",  english: "Italian",    flag: "🇮🇹" },
  { code: "ar", label: "العربية",    english: "Arabic",     flag: "🇸🇦", rtl: true },
  { code: "ja", label: "日本語",     english: "Japanese",   flag: "🇯🇵" },
  { code: "sv", label: "Svenska",   english: "Swedish",    flag: "🇸🇪" },
  { code: "af", label: "Afrikaans", english: "Afrikaans",  flag: "🇿🇦" },
];
